module.exports = __webpack_public_path__ + "static/media/alwayson.117bb33d.svg";